import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@emotion/react";
import theme from "muiTheme";
import { FloatButton } from "antd";
import { Tooltip } from "@mui/material";
import i18n from "i18n/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  
  <ThemeProvider theme={theme}>
    <App />
    <FloatButton.BackTop tooltip={i18n().scroll_to_top} className="bxShadow" style={{ borderRadius:"20px"}}/>
  </ThemeProvider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
